import { GridCellProps } from '@progress/kendo-react-grid';

type Props = {
  className?: string;
  e: GridCellProps;
  onClick?: (e) => void;
};

const TeamPositionCell = ({ className, e, onClick }: Props) => {
  const data = e?.dataItem?.name;
  return (
    <td className={className ?? ''}>
      <div style={{ color: '#101828' }}>{data}</div>
    </td>
  );
};

export default TeamPositionCell;
